import { useState, useEffect, useRef } from "react";
import { Drawer, Dropdown, Modal, message } from "antd";
import { Button, Col, DatePicker, Form, Input, Row, Select } from "antd";
import { useForm } from "antd/es/form/Form";
import TextArea from "antd/es/input/TextArea";
import dayjs from "dayjs";
import CommonFunctions from "../../Shared/CommonFunctions";
import PatientService from "../../../Services/PatientService";
import PatientChat from "./PatientChat";
import PatientInvite from "./PatientInvite";
import { FaVideo } from "react-icons/fa";
import StateMasterService from "../../../Services/StateMasterService";
import { CameraOutlined, FileOutlined } from "@ant-design/icons";
import PatientRegistration from "../../../Assets/Images/Svg/patientregister.svg";
import { FaRegEdit } from "react-icons/fa";
import { setSelectedRpmPatient } from "../../../Redux/actions/rpmActions";
import { APP_ROUTES } from "../../../PageRouting/approutes";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import UpArrow from "../../../Assets/Images/viewarrow.png";

function PatientList({ patientData, getPatientList, setPatientData }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [componentDisabled, setComponentDisabled] = useState(true);
  const [selectedChat, setSelectedChat] = useState({});
  const [open, setOpen] = useState(false);
  const [form] = useForm();
  const [inviteDetails, setInviteDetails] = useState({});
  const [invitePatient, setInvitePatient] = useState(false);
  const [paymentConsultationType, setPaymentConsultationType] = useState("");
  const [paymentReceived, setPaymentReceived] = useState(false);
  const [showPaymentCheckBox, setShowPaymentCheckBox] = useState(false);
  const [paymentType, setPaymentType] = useState("Digital");
  const [callType, setCallType] = useState("APPT_VIDEO");
  const [selectedEditPatient, setSelectedEditPatient] = useState(null);
  const [states, setStates] = useState([]);
  const [countries, setCountries] = useState([]);
  const [profileImageName, setProfileImageName] = useState("");
  const [profileImage, setProfileImage] = useState(null);
  const [photoValue, setPhotoValue] = useState(null);
  const [profileType, setProfileType] = useState(null);
  const fileInputRef = useRef(null);
  const videoRef = useRef(null);
  const canvasRef = useRef(null);
  const [isCameraOpen, setIsCameraOpen] = useState(false);
  const dispatch = useDispatch();
  const storedLoginResult = localStorage.getItem("login_result");
  const loginResultObject = storedLoginResult
    ? JSON.parse(storedLoginResult)
    : null;
  const history = useHistory();

  const showInviteModal = (record) => {
    setInviteDetails(record);
    setInvitePatient(true);
  };
  const handleInviteOk = () => {
    setPaymentConsultationType("");
    setPaymentReceived(false);
    setShowPaymentCheckBox(false);
    setPaymentType("Digital");
    setInvitePatient(false);
    setCallType("APPT_VIDEO");
  };
  const handleInviteCancel = () => {
    setPaymentConsultationType("");
    setPaymentReceived(false);
    setShowPaymentCheckBox(false);
    setPaymentType("Digital");
    setInvitePatient(false);
    setCallType("APPT_VIDEO");
  };

  const editPatient = (record) => {
    setSelectedEditPatient(record);
    if (record.dob) {
      const formattedDob = dayjs(record.dob, "MM/DD/YYYY");
      if (formattedDob.isValid()) {
        record.dob = formattedDob;
      } else {
        console.error("Invalid date format:", record.dob);
      }
    }
    form.setFieldsValue(record);
    setIsModalOpen(true);
  };

  const handleSubmit = () => {
    let data = form.getFieldValue();
    data.dob = dayjs(data.dob, "MM/DD/YYYY").format("MM/DD/YYYY");
    data.modifiedDate = CommonFunctions.convertUTCDate(
      new Date(),
      "YYYY-MM-DD HH:mm:ss"
    );
    if (photoValue) {
      data.photo = photoValue;
      data.photoType = profileType;
      data.photoName = profileImageName;
    }

    PatientService.EditPatient(data)
      .then((res) => {
        if (res.data === 1) {
          message.success("Patient Details updated successfully");
          setProfileType(null);
          setPhotoValue(null);
          setProfileImageName("");

          let payload = {
            account_Id: data.account_Id,
            patientId: data.patientId,
          };
          getPatientList(payload);
        } else {
          message.error("Failed to update patient details");
        }
      })
      .catch((error) => {
        message.error(
          "Updating patient details failed!. Please try again later."
        );
      })
      .finally(() => {
        form.resetFields();
        setIsModalOpen(false);
        setComponentDisabled(true);
      });
  };

  const handleCancel = () => {
    setComponentDisabled(true);
    form.resetFields();
    setProfileImage(null);
    setProfileImageName("");
    setPhotoValue(null);
    setProfileType(null);
    setIsModalOpen(false);
    stopCamera();
  };

  const handleDisabled = () => {
    setComponentDisabled(!componentDisabled);
  };

  const showDrawer = async (record) => {
    try {
      let payload = {
        patientId: record.patientId,
      };
      const res = await PatientService.PatientListFilter(payload);
      const dataObj = { ...record, photoName: res.data[0].photoName };
      setSelectedChat(dataObj);
    } catch (e) {
      console.error(e);
    }
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const genders = ["Male", "Female"];
  const salutationOptions = [
    {
      value: "Mr.",
      label: "Mr.",
    },
    {
      value: "Mrs.",
      label: "Mrs.",
    },
    {
      value: "Miss.",
      label: "Miss.",
    },
    {
      value: "Ms.",
      label: "Ms.",
    },
  ];
  const bloodgroup = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
  const maritalStatusOptions = [
    { label: "Married", value: "M" },
    { label: "Unmarried", value: "U" },
  ];
  const handleKeyPress = (e) => {
    const allowedKeys = [
      "0",
      "1",
      "2",
      "3",
      "4",
      "5",
      "6",
      "7",
      "8",
      "9",
      "Backspace",
      "Delete",
      "ArrowLeft",
      "ArrowRight",
      "Tab",
    ];
    if (!allowedKeys.includes(e.key)) {
      e.preventDefault();
    }
  };

  const getStateList = () => {
    let payload = {
      status: 1,
    };
    StateMasterService.StateMaster(payload).then((res) => {
      setStates(res.data);
    });
    StateMasterService.CountryMaster(payload).then((res) => {
      setCountries(res.data);
    });
  };

  useEffect(() => {
    getStateList();
  }, []);

  const initializeProfileImage = () => {
    if (selectedEditPatient?.photoName) {
      setProfileImage(
        process.env.REACT_APP_IMAGE_URL + selectedEditPatient.photoName
      );
    }
  };

  if (!profileImage && selectedEditPatient?.photoName) {
    initializeProfileImage();
  }

  const handleFileSelect = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const validImageTypes = ["image/jpeg", "image/png", "image/jpg"];
      if (!validImageTypes.includes(file.type)) {
        message.error("Only image files (JPG, PNG, JPEG) are allowed!");
        return;
      }

      const reader = new FileReader();
      reader.onloadend = () => {
        let imageArray = reader.result.split(",");
        setProfileImage(reader.result);
        setPhotoValue(imageArray[1]);
        setProfileType(file.type.split("/")[1]);
      };
      reader.readAsDataURL(file);
    }
  };

  const openCamera = async () => {
    setIsCameraOpen(true);
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });
      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error) {
      console.error("Error accessing camera:", error);
      message.error("Unable to access camera.");
    }
  };

  const stopCamera = () => {
    if (videoRef.current && videoRef.current.srcObject) {
      const stream = videoRef.current.srcObject;
      const tracks = stream.getTracks();
      tracks.forEach((track) => track.stop());
      videoRef.current.srcObject = null;
    }
    setIsCameraOpen(false);
  };

  const capturePhoto = () => {
    const canvas = canvasRef.current;
    const video = videoRef.current;
    const context = canvas.getContext("2d");
    context.drawImage(video, 0, 0, canvas.width, canvas.height);
    const imageDataUrl = canvas.toDataURL("image/png");
    setProfileImage(imageDataUrl);
    setPhotoValue(imageDataUrl.split(",")[1]);
    setProfileType("png");
    stopCamera();
  };

  const uploadOptions = [
    {
      key: "1",
      label: (
        <Button type="text" icon={<FileOutlined />} onClick={handleFileSelect}>
          Choose File
        </Button>
      ),
    },
    {
      key: "2",
      label: (
        <Button type="text" icon={<CameraOutlined />} onClick={openCamera}>
          Take Picture
        </Button>
      ),
    },
  ];

  const handlePatientPallette = (item) => {
    localStorage.setItem("rpmPatient", JSON.stringify(item));
    dispatch(setSelectedRpmPatient(item));
    history.push(APP_ROUTES.RPMPATIENTPALLETTE);
  };

  return (
    <>
      <Modal
        title="Invite Patient"
        open={invitePatient}
        onOk={handleInviteOk}
        onCancel={handleInviteCancel}
        footer={null}
        width={600}
        style={{
          top: 20,
        }}
        maskClosable={false}
      >
        <PatientInvite
          inviteDetails={inviteDetails}
          handleInviteOk={handleInviteOk}
          paymentConsultationType={paymentConsultationType}
          setPaymentConsultationType={setPaymentConsultationType}
          paymentReceived={paymentReceived}
          setPaymentReceived={setPaymentReceived}
          showPaymentCheckBox={showPaymentCheckBox}
          setShowPaymentCheckBox={setShowPaymentCheckBox}
          paymentType={paymentType}
          setPaymentType={setPaymentType}
          callType={callType}
          setCallType={setCallType}
        />
      </Modal>

      {Array.isArray(patientData) && patientData.length > 0 ? (
        <div className="w-full overflow-x-auto overflow-y-hidden">
          <table className="w-full border border-gray-200 shadow-md rounded-md customTable mt-4">
            <thead className="bg-[#F5FEFA] text-[#333333] text-left text-sm font-sans font-medium">
              <tr className="font-sans font-normal">
                <th className="p-3 whitespace-nowrap">Patient ID</th>
                <th className="p-3 whitespace-nowrap">Name </th>
                <th className="p-3 whitespace-nowrap">Email ID</th>
                <th className="p-3 whitespace-nowrap">Mobile</th>
                <th className="p-3 whitespace-nowrap">Clinic Name</th>
                <th className="p-3 whitespace-nowrap">Doctor Name</th>
                <th className="p-3 whitespace-nowrap">Action</th>
                {loginResultObject.user.rpmApplicable === "Y" && (
                  <th className="p-3 whitespace-nowrap">RPM</th>
                )}

                <th className="p-3 whitespace-nowrap">Status</th>
              </tr>
            </thead>
            <tbody>
              {patientData.map((record) => (
                <tr
                  key={record.patientId}
                  className="border-t border-gray-200 hover:bg-gray-50 font-sans font-medium text-sm text-[#333333]"
                >
                  <td className="p-3 whitespace-nowrap ">{record.patientId}</td>
                  <td className="p-3 whitespace-nowrap ">{`${record.firstName} ${record.lastName}`}</td>
                  <td className="p-3 whitespace-nowrap ">{record.email}</td>
                  <td className="p-3 whitespace-nowrap ">{record.mobile}</td>
                  <td className="p-3 whitespace-nowrap ">
                    {record.locationName}
                  </td>
                  <td className="p-3 whitespace-nowrap ">{record.userName}</td>
                  <td className="p-3 whitespace-nowrap ">
                    <div className="flex gap-2">
                      <FaVideo
                        className="text-[#189FAA] text-xl"
                        onClick={() => showInviteModal(record)}
                        role="button"
                      />
                      <FaRegEdit
                        role="button"
                        className="cursor-pointer w-5 h-5 text-[#189FAA]"
                        onClick={() => editPatient(record)}
                      />
                    </div>
                  </td>

                  {loginResultObject.user.rpmApplicable === "Y" && (
                    <td className="px-3 py-2 flex items-center justify-center">
                      <div className="flex items-center justify-center gap-2">
                        {record.rpmApplicable === "Y" ? (
                          <div
                            onClick={() => handlePatientPallette(record)}
                            title="Go to RPM"
                          >
                            <img
                              src={UpArrow}
                              alt="Navigate"
                              className="w-7 h-7 p-1 rounded-full cursor-pointer shadow"
                              // style={{ backgroundColor: "#189FAA " }}
                            />
                          </div>
                        ) : (
                          <span>&nbsp;</span>
                        )}
                      </div>
                    </td>
                  )}
                  <td className="p-3 whitespace-nowrap ">
                    <span
                      className={`${
                        record.status === 1
                          ? "p-1 rounded font-semibold text-[#189FAA]"
                          : "p-1 text-red-600 rounded-md"
                      }`}
                    >
                      {record.status === 1 ? "Active" : "Inactive"}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : null}
      <Modal
        title={
          <div className="flex justify-between ">
            <h2 className="font-bold text-xl">Edit Patient</h2>

            {componentDisabled ? (
              <button
                className="px-2 text-white font-normal rounded"
                onClick={handleDisabled}
              >
                Edit
              </button>
            ) : (
              <button
                className="px-2 text-white font-normal rounded"
                onClick={handleCancel}
              >
                X
              </button>
            )}
          </div>
        }
        open={isModalOpen}
        onCancel={handleCancel}
        footer={[]}
        width="60%"
        style={{
          top: 20,
        }}
        closeIcon={false}
      >
        <Form
          className="formDesign patientForm mt-3"
          name="basic"
          layout="vertical"
          autoComplete="off"
          form={form}
          onFinish={handleSubmit}
          disabled={componentDisabled}
        >
          <Row gutter={24} className=" border-2 rounded-md ">
            <div className="h-32 p-3 bg-[#F6FEFF] rounded-md w-full border-b">
              <div className="flex justify-between items-center">
                <div className="flex gap-6 relative">
                  <Dropdown menu={{ items: uploadOptions }} trigger={["click"]}>
                    <div className="Upload h-20 w-20 border-2 border-dashed p-4 rounded-full cursor-pointer">
                      <input
                        type="file"
                        accept="image/*"
                        style={{ display: "none" }}
                        onChange={handleFileChange}
                        ref={fileInputRef}
                      />
                      {profileImage ? (
                        <img
                          src={profileImage}
                          alt="Profile"
                          className="absolute top-0 left-0 w-full h-full object-cover rounded-full"
                        />
                      ) : (
                        <div className="absolute top-6 left-24 flex items-center">
                          <div className="bg-white border rounded-md h-7  w-28">
                            <span className="px-2 font-sans font-semibold">
                              Upload Profile
                            </span>
                          </div>
                        </div>
                      )}
                    </div>
                  </Dropdown>
                </div>
                <img src={PatientRegistration} alt="img" />
              </div>
            </div>

            {isCameraOpen && (
              <div className="camera-container">
                <video ref={videoRef} autoPlay className="w-full h-48" />
                <canvas
                  ref={canvasRef}
                  width="200"
                  height="200"
                  style={{ display: "none" }}
                />
                <div className="flex justify-between">
                  <Button
                    type="primary"
                    onClick={capturePhoto}
                    className="mt-2"
                  >
                    Capture
                  </Button>
                  <Button
                    type="default"
                    onClick={stopCamera}
                    className="mt-2 text-white"
                  >
                    Close
                  </Button>
                </div>
              </div>
            )}

            <div className="p-3 ">
              <p className=" font-sans font-semibold ">Personal Details</p>
              <Row gutter={20} className="mt-2">
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 rounded-md left-3 bg-white px-1  text-xs">
                      Salutation
                      <span className="text-red-500"> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="salutation"
                    rules={[
                      {
                        required: true,
                        message: "Please input salutation!",
                      },
                    ]}
                  >
                    <Select options={salutationOptions} className="w-full" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={9}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      First Name
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>

                  <Form.Item
                    name="firstName"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your First Name!",
                      },
                    ]}
                  >
                    <Input className="w-full" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={9}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Last Name
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="lastName"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter Last Name!",
                      },
                    ]}
                  >
                    <Input className="w-full" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      D.O.B
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="dob"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your D.O.B!",
                      },
                    ]}
                  >
                    <DatePicker className="w-full" format={"DD/MM/YYYY"} />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Gender
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="gender"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your Gender!",
                      },
                    ]}
                  >
                    <Select className="w-full">
                      {genders.map((option) => (
                        <Select.Option key={option} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Blood Group
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="bloodGroup"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your Blood Group!",
                      },
                    ]}
                  >
                    <Select className="w-full">
                      {bloodgroup.map((option) => (
                        <Select.Option key={option} value={option}>
                          {option}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={6}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Marital Status
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item name="maritalStatus">
                    <Select className="w-full">
                      {maritalStatusOptions.map((option) => (
                        <Select.Option key={option.value} value={option.value}>
                          {option.label}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Mobile Number
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="mobile"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your Mobile Number!",
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      maxLength={15}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Email ID
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="email"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your Email ID!",
                      },
                    ]}
                  >
                    <Input className="w-full" />
                  </Form.Item>
                </Col>
              </Row>
              <div className="font-sans font-semibold mt-1">
                Address Details
              </div>
              <Row gutter={20} className="mt-2">
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Address 1<span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="address1"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your contact address!",
                      },
                    ]}
                  >
                    <TextArea
                      autoSize={{
                        minRows: 1,
                        maxRows: 1,
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Address 2<span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item name="address2">
                    <TextArea
                      autoSize={{
                        minRows: 1,
                        maxRows: 1,
                      }}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={20}>
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      City
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>

                  <Form.Item
                    name="city"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your City",
                      },
                    ]}
                  >
                    <Input className="w-full" />
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Pincode
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="pinCode"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your Pincode",
                      },
                    ]}
                  >
                    <Input
                      className="w-full"
                      maxLength={6}
                      onKeyPress={handleKeyPress}
                    />
                  </Form.Item>
                </Col>

                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      State
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item
                    name="state"
                    rules={[
                      {
                        required: true,
                        message: "Please Enter your State",
                      },
                    ]}
                  >
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {states?.map((state) => (
                        <Select.Option
                          key={state.stateId}
                          value={state.stateId}
                        >
                          {state.stateName}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col xs={24} sm={12} md={8} lg={6} xl={12}>
                  <div className="relative mt-3">
                    <span className="absolute -top-2 text-gray-400 z-10 left-3 rounded-md bg-white px-1  text-xs">
                      Country
                      <span style={{ color: "#FF000F" }}> *</span>
                    </span>
                  </div>
                  <Form.Item name="country">
                    <Select
                      showSearch
                      optionFilterProp="children"
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {countries?.map((country) => (
                        <Select.Option
                          key={country.country_Id}
                          value={country.country_Id}
                        >
                          {country.country_Name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item>
                <div className="flex justify-end  border-brand-colorBorder gap-3 pt-2">
                  <Button
                    className="Btnwhite h-8 w-20 text-[#189FAA] border-2 border-[#979797]"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className="h-8 w-16  bg-brand-primaryColor"
                    type="primary"
                    htmlType="submit"
                    disabled={componentDisabled}
                  >
                    Save
                  </Button>
                </div>
              </Form.Item>
            </div>
          </Row>
        </Form>
      </Modal>

      <Drawer
        destroyOnClose
        // props={record}
        title={
          <div className="w-full flex items-center gap-3 m-0 p-3 bg-[#20638e] text-white">
            <div>
              <img
                src={process.env.REACT_APP_IMAGE_URL + selectedChat.photoName}
                className="w-10 h-10 rounded-full"
                alt="doctor"
              />
            </div>
            <div className="flex flex-col">
              <div>{`${selectedChat?.firstName} ${selectedChat?.lastName}`}</div>
              <div>({selectedChat?.patientId})</div>
            </div>
          </div>
        }
        onClose={onClose}
        open={open}
        closable={false}
      >
        <PatientChat selectedChat={selectedChat} />
      </Drawer>
    </>
  );
}

export default PatientList;
